var _ = require('lodash');



export default class inputAnimation {


    constructor(element) {
        this.config = {};
        this.config.selector = '.animate';
        this.selector = typeof this.config.selector === 'string' ? document.querySelectorAll(this.config.selector) : this.config.selector;

        if (this.selector) {
            this.init();
        }
    }


    updateTextField() {

        _.map(this.selector, (item) => {
            if (!_.isEmpty(item.value)) {
                item.classList.add('focus');
            }
        });
    }

    init() {
        _.map(this.selector, (item) => {
            let input = item.querySelector('input') || item.querySelector('textarea');
            if (input === null) {
                return false;
            }

            input.addEventListener('focus', () => {
                item.classList.add('focus');
            });

            input.addEventListener('blur', (a) => {
                if (_.isEmpty(input.value)) {
                    item.classList.remove('focus');
                }
            });

            input.addEventListener('input', (a) => {
                item.classList.add('focus');
            });
            if (input.value){
                input.dispatchEvent(new Event('focus'));

            }
        });
    }
}
